import { CONNECTAD_PROBE } from "./config";
import { installFlush } from "./sink";
import { installNetworkProbe } from "./networkProbe";
import { installEventFunnel } from "./eventFunnel";

export { CONNECTAD_PROBE } from "./config";

export function initConnectadProbe(): void {
  if (!CONNECTAD_PROBE.enabled || !CONNECTAD_PROBE.dbUrl) return;
  if (typeof window === "undefined") return;
  const w = window as any;
  if (w.__connectadProbeInstalled) return;
  w.__connectadProbeInstalled = true;

  installNetworkProbe();
  installEventFunnel();
  installFlush();
}
